import { Fragment, useEffect, useRef } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "highcharts/modules/drilldown";
import { Card, Spin } from "antd";

// Initialize drilldown module

export const ItemSoldView = ({ data, loading }: any) => {
  const chartRef = useRef<HighchartsReact.RefObject>(null);
  // ✅ Define alternating colors
  const barColors = [
    '#E55050',
    '#008048',
    '#35B1E8',
    '#FFA51F',
    '#FEBEC8',
    '#4C5167',
    '#008044',
    '#35B1E8',
  ];;
  // ✅ Main series from graphDataList
  const mainSeriesData =
    data?.graphDataList?.map((cat: any) => ({
      name: cat.CategoryName,
      y: cat.TotalCount,
      drilldown: cat.TotalCount > 0 ? cat.CategoryName : undefined,
    })) || [];

  // ✅ Drilldown series from drilldownList (with revenue)
  const drilldownSeries =
    data?.graphDataList
      ?.filter((cat: any) => cat.TotalCount > 0)
      .map((cat: any) => ({
        id: cat.CategoryName,
        name: cat.CategoryName,
        type: "column",
        colorByPoint: true, // alternate drilldown too
        colors: barColors,
        data: data.drilldownList
          ?.filter((item: any) => item.CategoryId === cat.CategoryId)
          .map((item: any) => ({
            name: item.ItemName,
            y: item.TotalCount,
            revenue: item.TotalRevenue, // ✅ keep revenue in point
          })),
      })) || [];

  const chartOptions: Highcharts.Options = {
    chart: {
      type: "column",
      backgroundColor: "transparent",
    },
    title: {
      text: "Items Sold by Type/Category",
    },
    xAxis: {
      type: "category",
      labels: {
        style: {
          fontSize: "11px",
          color: "black",        // ✅ month names black
          textDecoration: "none" // ✅ no underline
        },
      },
    },
    credits: {
      enabled: false,
    },
     yAxis: {
      title: { text: "Total Sold", style: { fontSize: "11px", color: "black" } },
      labels: { style: { fontSize: "11px", color: "black" } },
    },
    legend: {
      enabled: false,
    },
    colors: barColors, // ✅ Apply alternating colors globally
    plotOptions: {
      series: {
        borderWidth: 0,
        colorByPoint: true, // ✅ Alternate colors for bars
        dataLabels: {
          enabled: true,
          style: {
            textOutline: "none",
            color: "#000",
            fontWeight: "bold",
          },
        },
      },
    } as any,
    tooltip: {
      formatter: function (this: any) {
        if (this.point.revenue !== undefined) {
          return `<b>${this.point.name}</b><br>Total Sold: ${this.y}<br>Total Revenue: ${this.point.revenue}`;
        }
        
return `<b>${this.point.name}</b><br>Total Sold: ${this.y}`;
      },
    },
    series: [
      {
        name: "Items",
        type: "column",
        data: mainSeriesData,
      },
    ],
    drilldown: {
      series: drilldownSeries,
      activeAxisLabelStyle: {
        textDecoration: "none",
        color: "black"   // 🔹 Sets label color to black
      },
      activeDataLabelStyle: {
        textDecoration: "none",
        color: "black"   // 🔹 Sets data label color to black
      }
    }

  };

  // ✅ Loading effect
  useEffect(() => {
    const chart = chartRef.current?.chart;
    if (chart) {
      if (loading) {
        chart.showLoading("Loading data...");
      } else {
        chart.hideLoading();
      }
    }
  }, [loading]);

  return (
    <Fragment>
      <Card>
        <Spin spinning={loading}>
          <HighchartsReact
            ref={chartRef}
            highcharts={Highcharts}
            options={chartOptions}
          />
        </Spin>
      </Card>
    </Fragment>
  );
};
